<template>
    <div class="outer">
        <div id="login-template">
            <form>
                <h3>Sign In</h3>
                
                <div class="form-group">
                    <label>Email address</label>
                    <input type="email" v-model="email" class="form-control form-control-lg" />
                </div>
                
                <div class="form-group">
                    <label>Password</label>
                    <input type="password" v-model="password" @keyup.enter="login" class="form-control form-control-lg" />
                </div>
                
                <button type="button" @click.prevent="login" class="btn btn-dark btn-lg btn-block">Sign In</button>
            </form>
        </div>
    </div>
</template>

<script>
    import {auth} from '@/firebase/init'
    export default {
        name: 'Login',
        data(){
            return {
                email: null,
                password: null,
            }
        },
        methods: {
            login() {
                auth.signInWithEmailAndPassword(this.email, this.password)
                // route to admin mode    
                .then(() =>{
                    //this.$router.push('/'); // replace '' with url path for admin mode
                    //console.log("auth success");
                    this.$router.push({ name: 'Home' })
                })
                .catch(function(error) {
                    // Handle Errors here.
                    var errorCode = error.code;
                    if (errorCode === 'auth/wrong-password') {
                        alert('Wrong password.');
                    } else {
                        alert("Wrong credentials. Try again.");
                    }
                    console.log(error);
                });
            }
        }
    }
</script>

<style>
#login-template {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-image: none;
  background-color: wheat;
  color: #000000;
  padding-top: 5%;
  padding-left: 10%;
  padding-right: 10%;
  padding-bottom: 5%;
  display: block;
}

.outer{
    height: 100vh;
    padding-top: 5%;
}

#homebutton{
    align-self: left;
}
</style>